var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.submit}},[_vm._v("Log in")])])
}
var staticRenderFns = []

export { render, staticRenderFns }